import { createAction } from './types';

/**
 * Built-in actions (with autocomplete support)
 * New actions can be dynamically created with createAction()
 */
export const BUILTIN_ACTIONS = {
  PING: createAction('ping'),
  CHECK_EMAIL: createAction('check_email'),
  LOGIN_PASSWORD: createAction('login_password'),
  REGISTER: createAction('register'),
  API_CART: createAction('api_cart'),
  API_WISHLIST: createAction('api_wishlist'),
} as const;

/** Environment variable key */
export const RECAPTCHA_SITE_KEY_ENV = 'NEXT_PUBLIC_RECAPTCHA_SITE_KEY';

/** Token header name */
export const RECAPTCHA_TOKEN_HEADER = 'X-Recaptcha-Token';

/** Error messages (user-facing) */
export const RECAPTCHA_ERROR_MESSAGES = {
  RECAPTCHA_MISSING: 'Unable to process request.',
  RECAPTCHA_EXPIRED: 'Please refresh the page and try again.',
  RECAPTCHA_INVALID: 'Unable to process request. Please try again.',
  RECAPTCHA_ACTION_MISMATCH: 'Unable to process request.',
  RECAPTCHA_LOW_SCORE: 'Security verification failed. Please try again later.',
  RECAPTCHA_NETWORK_ERROR: 'A temporary error occurred.',
} as const;
